import { createTheme } from '@mui/material/styles';
import { palette, typography, spacing, breakpoints, components } from '../../../theme';

/**
 * MashieWeb React Theme
 *
 * Uses centralized theme constants from Content/js/theme/
 * This ensures consistency between legacy MashieWeb and modern Next.js frontend.
 */
const theme = createTheme({
  palette: {
    primary: palette.primary,
    secondary: palette.secondary,
    success: palette.success,
    info: palette.info,
    warning: palette.warning,
    error: palette.error,
    background: palette.background,
    text: palette.text,
    divider: palette.divider,
    grey: palette.grey,
  },

  typography: {
    fontFamily: typography.fontFamily,
    fontSize: typography.fontSize,
    fontWeightLight: typography.fontWeightLight,
    fontWeightRegular: typography.fontWeightRegular,
    fontWeightMedium: typography.fontWeightMedium,
    fontWeightBold: typography.fontWeightBold,
    h1: typography.h1,
    h2: typography.h2,
    h3: typography.h3,
    h4: typography.h4,
    h5: typography.h5,
    h6: typography.h6,
    body1: typography.body1,
    body2: typography.body2,
    button: typography.button,
    caption: typography.caption,
    overline: typography.overline,
  },

  spacing: spacing.unit,

  shape: {
    borderRadius: 4, // Bootstrap @border-radius-base
  },

  breakpoints: {
    values: breakpoints.values,
  },

  components,
});

export default theme;
